import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { any, func, number } from 'prop-types';
import React from 'react';
/**
 * This render props component willupdate it's children via props while executing data loaders sent as props to the component.
 *
 * Note: Dataloaders are made to be at an app level to keep the component generic, the return of Dataloaders are sent as props to its children.
 *
 * Example
 *  ```javascript
 *  import {UpdateOnInterval} from '@quintype/components';
 *
 *  const story = {
 *     'example' : 'data'
 *  };
 *
 *  function getData() {
 *      return fetch('/url/something')//...
 *  }
 *
 * <UpdateOnInterval dataLoader={getData} interval={3000} initData={story}>
 *   {
 *     ({data}) => <Component data={data}></Component>
 *   }
 * </UpdateOnInterval>
 *  ```
 * @component
 * @hideconstructor
 * @category Other
 */

export var UpdateOnInterval = /*#__PURE__*/function (_React$Component) {
  _inherits(UpdateOnInterval, _React$Component);

  var _super = /*#__PURE__*/_createSuper(UpdateOnInterval);

  function UpdateOnInterval(props) {
    var _this;

    _classCallCheck(this, UpdateOnInterval);

    _this = _super.call(this, props);
    _this.fetchIntervalIndex = -1;
    _this.state = {
      data: _this.props.initData
    };
    return _this;
  }

  _createClass(UpdateOnInterval, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.registerInterval();
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      this.unregisterInterval();
    }
  }, {
    key: "registerInterval",
    value: function registerInterval() {
      var _this2 = this;

      this.fetchIntervalIndex = setInterval(function () {
        return _this2.setData();
      }, this.props.interval);
    }
  }, {
    key: "unregisterInterval",
    value: function unregisterInterval() {
      clearInterval(this.fetchIntervalIndex);
    }
  }, {
    key: "setData",
    value: function () {
      var _setData = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(typeof this.props.dataLoader === 'function')) {
                  _context.next = 6;
                  break;
                }

                _context.next = 3;
                return this.props.dataLoader();

              case 3:
                _context.t0 = _context.sent;
                _context.next = 7;
                break;

              case 6:
                _context.t0 = {};

              case 7:
                data = _context.t0;
                this.setState({
                  data: data
                });

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function setData() {
        return _setData.apply(this, arguments);
      }

      return setData;
    }()
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var data = this.state.data;
      return children({
        data: data
      });
    }
  }]);

  return UpdateOnInterval;
}(React.Component);
UpdateOnInterval.defaultProps = {
  interval: 30000,
  initData: {}
};